import { Badge, Box, Flex, Text } from "@chakra-ui/react";
import React from "react";

type Comic = {
  title: string;
  thumbnail: string;
  story: string;
  order: number;
};

const SuggestionComicPreview = ({
  comic,
  isDeletion = false,
}: {
  comic: Comic;
  isDeletion: boolean;
}) => {
  return (
    <Flex alignItems="center" pt="3">
      <Box pr="2">
        <Badge
          bg={isDeletion ? "red.500" : "gray.600"}
          borderRadius="sm"
          fontSize="0.8em"
        >
          {comic.order}
        </Badge>
      </Box>
      <Box flex="1">
        <Text as={isDeletion ? "del" : "span"}>
          {comic.title} {comic.story}
        </Text>
      </Box>
    </Flex>
  );
};

export default SuggestionComicPreview;
